import { DependencyList, useEffect } from 'react'
import { MapRef } from 'react-map-gl/mapbox'

export const useMapResize = ({
  mapRef,
  dependencies,
}: {
  mapRef: MapRef | undefined
  dependencies: DependencyList
  delay?: number
}) => {
  useEffect(() => {
    if (!mapRef) return

    let resizeObserver: ResizeObserver

    // Use ResizeObserver to detect when the map container actually changes size
    const container = mapRef.getContainer()
    if (container) {
      resizeObserver = new ResizeObserver(() => {
        mapRef.resize()
      })
      resizeObserver.observe(container)
    }

    // Also trigger on dependencies change
    mapRef.resize()

    return () => {
      if (resizeObserver) resizeObserver.disconnect()
    }
    // dependencies is a parameter — trigger when caller deps change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies)
}
